import { MAP_SHEET_HEIGHT_RATIO } from '@components/map/sheet/constants';
import { MapRecord } from '@root/globalTypes';

export const hasCoords = (data: MapRecord) => {
  const { lat, lon } = data;
  if (lat && lon) return true;
  return false;
};

export const focusOnElement = (id: string) => {
  setTimeout(() => {
    const mapListWrapper = document.querySelector('.map-list') as HTMLDivElement;
    const mapListItem = document.querySelector(`#map-list-item-${id}`) as HTMLLIElement;
    if (!mapListWrapper || !mapListItem) return;
    // eslint-disable-next-line immutable/no-mutation
    mapListWrapper.scrollTop = mapListItem.offsetTop;
  }, 10);
};

export const getSheetPanOffset = (element: HTMLElement) => {
  const { top, height } = element.getBoundingClientRect();
  const sheetTop = window.innerHeight * (1 - MAP_SHEET_HEIGHT_RATIO);
  return Math.max(0, top + height / 2 - (top + Math.min(sheetTop, top + height)) / 2);
};

export const getClusterRecords = (data: MapRecord[], clusterIds: string[]) => {
  if (!clusterIds.length) return undefined;
  const records = data.filter((el) => clusterIds.includes(el.id));
  return records.length ? records : undefined;
};
